import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import './index.css';
import App from './App';
import { installSessionExpiryInterceptor } from './auth/sessionExpiry';
import reportWebVitals from './reportWebVitals';

installSessionExpiryInterceptor(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

reportWebVitals();
